import { createStore, applyMiddleware, compose } from 'redux';
import { createLogger } from 'redux-logger';
import createSagaMiddleware from 'redux-saga';
import { rootReducer } from 'store/root-reducer';
import rootSaga from '../sagas';

const logger = createLogger({ collapsed: true });

const sagaMiddleware = createSagaMiddleware();

const middleware = [sagaMiddleware];
if (NODE_ENV !== 'production') {
  middleware.unshift(logger);
}

const enhancer = compose(applyMiddleware(...middleware));

export const store = createStore(rootReducer, enhancer);

sagaMiddleware.run(rootSaga);

if (__ENV === 'development' || __ENV === 'localhost') {
  window.store = store;
}

export default store;
